import { empty, handleHttpMethod } from 'ant-design-vue-admin-x';

export default {
  data () {
    return {
      areaIndex: 1,
      singleOption: [],
      cascadeParam: {},
      regionUrl: {
        JAVA: '/regions/treeselect',
        PHP: '/get_area_tree'
      },
      propertyUrl: {
        JAVA: '/property/treeselect',
        PHP: '/select_list/property_list'
      },
      communityUrl: {
        JAVA: '/community/treeselect',
        PHP: '/select_list/community_list'
      },
      buildUrl: {
        JAVA: '/building/treeselect',
        PHP: '/select_list/community_building_list'
      },
      unitUrl: {
        JAVA: '/units/treeselect',
        PHP: '/select_list/community_units_list'
      },
      roomUrl: {
        JAVA: '/room/treeselect',
        PHP: '/select_list/community_room_list'
      },
      positionUrl: {
        JAVA: '/position/treeselect',
        PHP: '/select_list/position_list'
      },
      deviceUrl: {
        JAVA: '/device/treeselect',
        PHP: '/select_list/devices_list'
      }
    };
  },
  methods: {
    /** 测试获取小区下拉 */
    getCommunitySelect (pageNum, keywords, item, scrollFetch) {
      return new Promise((resolve, reject) => {
        this.$get({
          url: '/community/list',
          params: {
            keywords: keywords,
            pageNum: pageNum || 1,
            pageSize: 10
          }
        }).then(({ data }) => {
          let arr = data.rows && data.rows.map(item => ({ value: item.communityId, label: item.communityName }));

          if (scrollFetch) {
            item.options = [...item.options, ...arr];
          } else {
            item.options = arr;
          }

          item.paginationTotal = data.total;
          item.totalPage = data.totalPage;
          resolve(data);
        });
      });
    },
    /* 获取用户范围下拉列表 */
    userRangeList (regionIndex, communityIndex, fn1, fn2) {
      this.provinceCitySelect((data) => {
        this.formList[regionIndex].options = data;
        fn1 && fn1(data); // 需要时可以添加回调
      });

      this.communitySelect((data) => {
        if (this.apiOrigin === 'PHP') {
          data = data.community_list;
        }
        let arr = data && data.map(el => ({ key: `${el.value}`, title: el.label }));
        this.formList[communityIndex].options = arr;
        fn2 && fn2(arr); // 需要时可以添加回调
      });
    },
    /** 处理 api 默认类型 */
    apiType (urlObj) {
      this.apiOrigin = this.apiOrigin || 'JAVA';
      return urlObj[this.apiOrigin];
    },
    /** 获取省市区列表（通过parentId） */
    newRegionSelectByIds (index, areas, levelLimit = 3, additionalParameters) {
      if (this.areaIndex < areas.length) {
        let oldOptions = this.formList[index].options;
        let i = this.areaIndex - 1;
        if (areas[i] === 0 || areas[i] === '0') {
          return;
        }
        this.findOptionsId(oldOptions, areas[i]);

        let url = 'regions/list';
        this[handleHttpMethod('get', this)]({
          url: url,
          params: {
            parentId: areas[i],
            ...additionalParameters
          }
        }).then(({ data }) => {
          this.areaIndex = this.areaIndex + 1;
          data && data.forEach(item => {
            if (item.level >= levelLimit || item.hasNext == 0 || item.nextLevel > levelLimit) {
              item.isLeaf = true;
            } else {
              item.isLeaf = false;
            }
          });
          this.singleOption.children = data.filter(item => {
            if (item.level <= levelLimit) {
              return item;
            }
          }); ;
          let region = this.formList[index];
          region.options = [...region.options];

          this.newRegionSelectByIds(index, areas, levelLimit);
        });
      }
    },
    /** 获取省市区列表（通过parentId） */
    regionSelectByIds (index, areas) {
      if (this.areaIndex < areas.length) {
        let oldOptions = this.formList[index].options;
        let i = this.areaIndex - 1;
        this.findOptionsId(oldOptions, areas[i]);

        let url = this.apiType(this.regionUrl);
        this[handleHttpMethod('get', this)]({
          url: url,
          params: {
            type: this.areaIndex + 1, // 获取省市区第几层级的返回数据
            parentId: areas[i]
          }
        }).then(({ data }) => {
          this.areaIndex = this.areaIndex + 1;
          data && data.forEach(item => {
            item.isLeaf = false;
          });
          this.singleOption.children = data;
          let region = this.formList[index];
          region.options = [...region.options];

          this.regionSelectByIds(index, areas);
        });
      }
    },
    findOptionsId (oldOptions, id) {
      let len = oldOptions.length;
      for (let index = 0; index < len; index++) {
        let item = oldOptions[index];
        if (item.value === id) {
          this.singleOption = item;
          return;
        }
        if (item.children && item.children.length) {
          this.findOptionsId(item.children, id);
        }
      }
    },
    /** 获取省市下拉（一次性返回两级） */
    provinceCitySelect (index, scope = 'searchList') {
      this.$get({
        url: '/regions/cityTreeSelect',
        params: {}
      }).then(({ data }) => {
        let argument = arguments[0];
        if (argument && typeof argument === 'function') {
          argument(data);
        } else {
          this[scope][index].options = data;
        }
      });
    },
    /* 获取省市区 新接口 */
    newRegionSelect (index, scope = 'searchList', type = '1,2,3', event, additionalParameters) {
      return new Promise((resolve, reject) => {
        let option = {};
        let current = 1;
        type = type.split(',').length;
        if (event) {
          current = event.length + 1;
          option = event[event.length - 1];
          option.loading = true;
        }

        let url = 'regions/list';
        this[handleHttpMethod('get', this)]({
          url: url,
          params: { parentId: option.value, ...additionalParameters}
        }).then(({data}) => {
          data.forEach((el, i) => {
            if (el.hasNext == 1) {
              if (current >= type || el.nextLevel > type) {
                el.isLeaf = true;
              } else {
                el.isLeaf = false;
              }
            } else {
              el.isLeaf = true;
            }
          });

          if (event) {
            option.loading = false;
            option.children = data.filter(item => {
              if (item.level <= type) {
                return item;
              }
            });
            let region = this[scope][index];
            region.options = [...region.options];
          } else {
            let argument = arguments[0];
            if (argument && typeof argument === 'function') {
              argument(data);
            } else {
              this[scope][index].options = data;
            }
          }
          resolve();
        }).catch(() => {
          option.loading = false;
        });
      });
    },
    /* 获取省市区 */
    regionSelect (index, scope = 'searchList', type = '1,2,3', event) {
      return new Promise((resolve, reject) => {
        let option = {};
        let current;
        type = type.split(',').length;
        if (event) {
          current = event.length + 1;
          option = event[event.length - 1];
          option.loading = true;
        }

        let url = this.apiType(this.regionUrl);
        this[handleHttpMethod('get', this)]({
          url: url,
          params: { type: current, parentId: option.value }
        }).then(({data}) => {
          data.forEach((el) => {
            current === type || current === 4 ? el.isLeaf = true : el.isLeaf = false;
          });

          if (event) {
            option.loading = false;
            option.children = data;

            let region = this[scope][index];
            region.options = [...region.options];
          } else {
            let argument = arguments[0];
            if (argument && typeof argument === 'function') {
              argument(data);
            } else {
              this[scope][index].options = data;
            }
          }
          resolve();
        }).catch(() => {
          option.loading = false;
        });
      });
    },
    /* 获取物业下拉 */
    propertySelect (index, scope = 'searchList') {
      let url = this.apiType(this.propertyUrl);
      this[handleHttpMethod('get', this)]({
        url: url,
        params: {}
      }).then(({data}) => {
        this[scope][index].options = data;
      });
    },
    communitySelectByStep (pageNum, search, scope = 'formList', index = '2', exitValue, area, istransfer = false) {
      let targetDom = scope == 'formList' ? this.$refs.form || this.$refs.addEdit : this.$refs.table;
      if (exitValue && exitValue.indexOf(',') > -1) {
        return new Promise((resolve, reject) => {
          let params = {};
          let areas;
          if (area) {
            areas = area.toString();
          }
          if (pageNum == undefined) {
            params = {
              search,
              pageNum: 1,
              pageSize: 30,
              areas,
              ids: exitValue
            };
          } else {
            params = {
              search,
              pageNum,
              pageSize: 30,
              areas,
              ids: exitValue
            };
          }
          this.$get({
            url: '/community/treeselect/page',
            params
          }).then(({data}) => {
            let newArr = data.rows;

            if (pageNum == undefined || pageNum == 1) {
              targetDom && (targetDom.selectCurrentPage = 1);
              if (istransfer) {
                let arr = newArr && newArr.map(el => ({ key: `${el.value}`, title: el.label }));
                this[scope][index].options = [].concat(arr);
                this[scope][index].totalPage = data.totalPage;
              } else {
                this[scope][index].options = [].concat(newArr);
                this[scope][index].totalPage = data.totalPage;
              }
            } else {
              if (istransfer) {
                let arr = newArr && newArr.map(el => ({ key: `${el.value}`, title: el.label }));
                this[scope][index].options = this[scope][index].options.concat(arr);
                this[scope][index].totalPage = data.totalPage;
              } else {
                this[scope][index].options = this[scope][index].options.concat(newArr);
                this[scope][index].totalPage = data.totalPage;
              }
            }

            resolve({
              total: data.total,
              totalPage: data.totalPage
            });
          }, (err) => {
            console.log('Err', err);
          });
        });
      } else {
        return new Promise((resolve, reject) => {
          let params = {};
          let areas;
          if (area) {
            areas = area.toString();
          }
          if (pageNum == undefined) {
            params = {
              search,
              pageNum: 1,
              pageSize: 30,
              areas,
              ids: exitValue
            };
          } else {
            params = {
              search,
              pageNum,
              pageSize: 30,
              areas,
              ids: exitValue
            };
          }
          this.$get({
            url: '/community/treeselect/page',
            params
          }).then(({data}) => {
            let newArr = [];
            if (exitValue && params.pageNum != 1) {
              let oldArr = data.rows;
              newArr = oldArr.filter(item => item.value != exitValue);
            } else {
              newArr = data.rows;
            }

            if (pageNum == undefined || pageNum == 1) {
              targetDom && (targetDom.selectCurrentPage = 1);
              if (istransfer) {
                let arr = newArr && newArr.map(el => ({ key: `${el.value}`, title: el.label }));
                this[scope][index].options = [].concat(arr);
                this[scope][index].totalPage = data.totalPage;
              } else {
                this[scope][index].options = [].concat(newArr);
                this[scope][index].totalPage = data.totalPage;
              }
            } else {
              if (istransfer) {
                let arr = newArr && newArr.map(el => ({ key: `${el.value}`, title: el.label }));
                this[scope][index].options = this[scope][index].options.concat(arr);
                this[scope][index].totalPage = data.totalPage;
              } else {
                this[scope][index].options = this[scope][index].options.concat(newArr);
                this[scope][index].totalPage = data.totalPage;
              }
            }

            resolve({
              total: data.total,
              totalPage: data.totalPage
            });
          }, (err) => {
            console.log('Err', err);
          });
        });
      }
    },

    /* 获取小区下拉 */
    communitySelect (index, scope = 'searchList', isPosition) {
      return new Promise(resolve => {
        let url = this.apiType(this.communityUrl);
        this[handleHttpMethod('get', this)]({
          url: url,
          params: {
            search: '',
            isShowPosition: isPosition || 0
          }
        }).then(({data}) => {
          let argument = arguments[0];
          if (argument && typeof argument === 'function') {
            argument(data);
          } else {
            if (Array.isArray(data)) {
              this[scope][index].options = data;
            } else {
              this[scope][index].options = data.community_list;
            }
          }
          resolve(data);
        });
      });
    },
    /* 获取楼栋下拉 */
    buildSelect (index, cascadeParam = {}, scope = 'searchList') {
      let url = this.apiType(this.buildUrl);
      this[handleHttpMethod('get', this)]({
        url: url,
        params: {
          communityId: cascadeParam[`${this.$route.name}/communityId`],
          search: ''
        }
      }).then(({data}) => {
        try {
          this[scope][index].options = data;
        } catch {
          this.tempSearchList[0].options = data;
        }
      });
    },
    /* 获取单元下拉 */
    unitSelect (index, cascadeParam = {}, scope = 'searchList') {
      let url = this.apiType(this.unitUrl);
      this[handleHttpMethod('get', this)]({
        url: url,
        params: {
          communityId: cascadeParam[`${this.$route.name}/communityId`],
          buildingId: cascadeParam[`${this.$route.name}/buildingId`],
          search: ''
        }
      }).then(({data}) => {
        this[scope][index].options = data;
      });
    },
    /* 获取房间下拉 */
    roomSelect (index, cascadeParam = {}, scope = 'searchList') {
      let url = this.apiType(this.roomUrl);
      this[handleHttpMethod('get', this)]({
        url: url,
        params: {
          communityId: cascadeParam[`${this.$route.name}/communityId`],
          buildingId: cascadeParam[`${this.$route.name}/buildingId`],
          unitsId: cascadeParam[`${this.$route.name}/unitId`]
        }
      }).then(({data}) => {
        this[scope][index].options = data;
      });
    },

    /* 获取位置下拉 */
    positionSelect (index, cascadeParam = {}, scope = 'searchList') {
      let url = this.apiType(this.positionUrl);
      this[handleHttpMethod('get', this)]({
        url: url,
        params: {
          communityId: cascadeParam.communityId,
          search: ''
        }
      }).then(({data}) => {
        this[scope][index].options = data;
      });
    },
    /* 获取设备下拉 */
    deviceSelect (index, cascadeParam = {}, scope = 'searchList') {
      let url = this.apiType(this.deviceUrl);
      this[handleHttpMethod('get', this)]({
        url: url,
        params: {
          positionId: cascadeParam.positionId,
          search: ''
        }
      }).then(({data}) => {
        this[scope][index].options = data;
      });
    },
    /* 获取产品分类 */
    categorySelect (index = 0, scope = 'searchList', level = 4) {
      this.$get({
        url: '/category/product/get_category_list',
        params: { level: level }
      }).then(({data}) => {
        this[scope][index].options = data;
      });
    },
    /* 小区change,联动位置列表 */
    communityChange_getPosi (index, val, scope) {
      this.cascadeParam.communityId = val;
      this.positionSelect(index, this.cascadeParam, scope);
    },
    /* 小区change,联动位置列表 */
    positionChange (index, val, scope) {
      this.cascadeParam.positionId = val;
      this.deviceSelect(index, this.cascadeParam, scope);
    },

    /* 小区change,联动楼栋列表 */
    communityChange (index, val, scope) {
      let resetKey = [`${this.$route.name}/buildingId`, `${this.$route.name}/unitId`, `${this.$route.name}/roomId`];
      this.resetSub(resetKey);
      this.cascadeParam[`${this.$route.name}/communityId`] = val;
      this.buildSelect(index, this.cascadeParam, scope);
    },
    /* 楼栋change，联动单元列表 */
    buildingChange (index, val, scope) {
      let resetKey = [`${this.$route.name}/unitId`, `${this.$route.name}/roomId`];
      this.resetSub(resetKey);
      this.cascadeParam[`${this.$route.name}/buildingId`] = val;
      this.unitSelect(index, this.cascadeParam, scope);
    },
    /* 单元change，联动房间列表 */
    unitChange (index, val, scope) {
      let resetKey = [`${this.$route.name}/roomId`];
      this.resetSub(resetKey);
      this.cascadeParam[`${this.$route.name}/unitId`] = val;
      this.roomSelect(index, this.cascadeParam, scope);
    },
    /** 清除所有的子集 */
    resetSub (resetKey) {
      if (this.$refs.addEdit) { // 使用addEdit组件时，需声明ref addEdit变量
        this.$refs.addEdit.resetSubValue(resetKey);
      } else {
        empty.$emit('resetForm', resetKey);
      }
    },

    /* 会员管理下拉（会员管理模块） */
    memberManageSelect (paramArr) {
      this.$get({
        url: '/select_list/member_manage_list',
        params: {}
      }).then(({data}) => {
        paramArr.forEach((ele) => {
          this[ele.scope || 'searchList'][ele.index].options = data[ele.key];
        });
      });
    },
    /*  设备管理下拉（设备管理模块） */
    deviceManageSelect (paramArr, query) {
      this.$get({
        url: '/select_list/devices_manage_list',
        params: query
      }).then(({data}) => {
        paramArr.forEach((ele) => {
          this[ele.scope || 'searchList'][ele.index].options = data[ele.key];
        });
      });
    },
    // 根据类型获取字典下拉
    dictionarySelect (paramArr) {
      paramArr.forEach(item => {
        this.$get({
          url: `/dict/data/dictType/${item.query}`
        }).then(({data}) => {
          if (item.handle && typeof item.handle === 'function') {
            item.handle(data);
          } else {
            this[item.scope || 'searchList'][item.index].options = data;
          }
        });
      });
    },
    /*  物业管理下拉（物业管理模块） */
    propertyManageSelect (paramArr) {
      this.$get({
        url: '/role/property/treeSelect',
        params: {}
      }).then(({data}) => {
        paramArr.forEach((ele) => {
          this[ele.scope || 'searchList'][ele.index].options = data[ele.key] || data;
        });
      });
    },
    /*  运营管理下拉（运营管理模块） */
    marketingManageSelect (param) {
      this._get({
        url: '/select_list/operate_manage_list',
        params: {}
      }).then(({data}) => {
        if (param && typeof param === 'function') {
          param(data);
        } else {
          param.forEach((ele) => {
            this[ele.scope || 'searchList'][ele.index].options = data[ele.key];
          });
        }
      });
    },
    /* 获取通用类别（晓纹接口） */
    typeSelect (params) {
      this._get({
        url: '/get_typedesc',
        params: { type: params.query, format: params.format }
      }).then(({data}) => {
        if (params.handle && typeof params.handle === 'function') {
          params.handle(data);
        } else {
          this[params.scope || 'formList'][params.index].options = data;
        }
      });
    },
    /* 获取角色列表 */
    roleSelect (handle) {
      this.$get({
        url: '/get_roles_tree',
        params: {}
      }).then(({data}) => {
        if (typeof handle === 'function') {
          handle(data);
        }
      });
    }
  }
};
